import type { CSSProperties, ReactNode } from "react"

import { getStylePreset, stylePresetToCssVariables, type StylePresetId } from "@/lib/style-presets"
import { cn } from "@/lib/utils"

export type ThemeScopeProps = {
  preset?: StylePresetId
  className?: string
  children: ReactNode
}

/** Applies a style preset to every token-based component inside this wrapper. */
export function ThemeScope({ preset = "luxury-editorial", className, children }: ThemeScopeProps) {
  const stylePreset = getStylePreset(preset) ?? getStylePreset("luxury-editorial")
  const themeVariables = stylePreset ? stylePresetToCssVariables(stylePreset) : {}

  return (
    <div
      data-theme-preset={preset}
      style={themeVariables as CSSProperties}
      className={cn("min-h-screen bg-background text-foreground", className)}
    >
      {children}
    </div>
  )
}

export function themeVariablesForPreset(preset: StylePresetId): CSSProperties {
  const stylePreset = getStylePreset(preset)
  return stylePreset ? stylePresetToCssVariables(stylePreset) as CSSProperties : {}
}
